import React, {useEffect, useState} from 'react'
import {searchCust} from "../../../services/api/apiCustomers"
import parseToken from "../../../helpers/parseToken"
import {Spin} from "antd"
import BlockLeft from "./layout/default/block-left/BlockLeft"
import CustomerDetailProvider from "./CustomerDetailProvider"
import BlockRight from "./layout/default/block-right/BlockRight"
import BlockCenter from "./layout/default/block-center/BlockCenter"
import getHistory from "../../../store/getHistory"

function CustomerDetailPage(props) {
    const decodeToken = parseToken()
    const {custId, onChangeMainTab, onChangeActiveTab} = props

    const [loading, setLoading] = useState(false)
    const [customerInformation, setCustomerInformation] = useState({})

    const _fetchCustomerDetail = async () => {
        setLoading(true)

        try {
            const payload = {
                custId,
            }
            const response = await searchCust(payload, decodeToken.sub)

            const {success, data} = response

            if (parseInt(success) !== 1) {
                return setLoading(false)
            }

            setLoading(false)
            setCustomerInformation(data[0])
        } catch (e) {
            setLoading(false)
        }
    }

    const _onActiveTabDefault = value => {
        const history = getHistory()
        history.push('/crm/customers')
        onChangeMainTab({id: 'customers', title: 'Quản lý khách hàng', icon: ''})
        onChangeActiveTab({id: 'customers'})
    }

    useEffect(() => {
        _fetchCustomerDetail()
        // eslint-disable-next-line
    }, [])

    return (
        <CustomerDetailProvider
            customerInformation={customerInformation}
        >
            <Spin spinning={loading}>
                <div className="CaseDetailPage">
                    <div className="HeadPage">
                        <div className="Heading">
                            <span onClick={_onActiveTabDefault}>
                                <span className="material-icons">arrow_back</span>
                                <span className="Title">Back to list</span>
                            </span>
                            <div className="Company">
                                <span className="material-icons">person</span>
                                <span className="Name">{customerInformation.name}</span>
                            </div>
                        </div>
                        <div className="Actions">
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-3 Block1">
                            <BlockLeft/>
                        </div>
                        <div className="col-6 Block2">
                            <BlockCenter custId={custId}/>
                        </div>
                        <div className="col-3 Block3">
                            <BlockRight custId={custId}/>
                        </div>
                    </div>
                </div>
            </Spin>
        </CustomerDetailProvider>
    )
}

export default CustomerDetailPage
